import {
	CLEAR_VALIDATION_STATE,
	ADD_VALIDATION_FAILURE,
	REMOVE_VALIDATION_FAILURE,
	SET_VALIDATION_TRIGGER,
	SET_VALIDATION_TRIGGER_SUPPRESS_MESSAGES
} from './validation-mutation-types';
import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';

const initialValidationState = {
	valid: true,
	components: []
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'validation',
	namespaced: true,
	state: {
		validationState: initialValidationState,
		validationTrigger: undefined,
		validationTriggerSuppressMessages: undefined
	},
	mutations: {
		[CLEAR_VALIDATION_STATE](state) {
			Vue.set(state.validationState, 'valid', true);
			Vue.set(state.validationState, 'components', []);
		},
		[ADD_VALIDATION_FAILURE](
			state,
			{ componentUniqueId, valid, messages }
		) {
			const index = state.validationState.components.findIndex(
				m => m.componentUniqueId === componentUniqueId
			);
			if (index >= 0) {
				//repalce the item
				state.validationState.components.splice(index, 1, {
					componentUniqueId,
					valid,
					messages
				});
			} else {
				//add the item
				state.validationState.components.splice(0, 0, {
					componentUniqueId,
					valid,
					messages
				});
			}

			Vue.set(state.validationState, 'valid', false);
		},
		[REMOVE_VALIDATION_FAILURE](state, componentUniqueId) {
			const index = state.validationState.components.findIndex(
				m => m.componentUniqueId === componentUniqueId
			);

			if (index >= 0) {
				state.validationState.components.splice(index, 1);
			}

			if (state.validationState.components.length === 0) {
				Vue.set(state.validationState, 'valid', true);
			}
		},
		[SET_VALIDATION_TRIGGER](state) {
			state.validationTrigger = uuidv4();
		},
		[SET_VALIDATION_TRIGGER_SUPPRESS_MESSAGES](state) {
			state.validationTriggerSuppressMessages = uuidv4();
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch })
		clearValidationStateAction({ commit }) {
			commit(CLEAR_VALIDATION_STATE);
		},
		validationAction({ commit }, { componentUniqueId, valid, messages }) {
			if (!valid) {
				commit(ADD_VALIDATION_FAILURE, {
					componentUniqueId,
					valid,
					messages
				});
			} else {
				commit(REMOVE_VALIDATION_FAILURE, componentUniqueId);
			}
		},
		addValidationFailureAction(
			{ commit },
			{ componentUniqueId, messages }
		) {
			commit(ADD_VALIDATION_FAILURE, { componentUniqueId, messages });
		},
		removeValidationFailureAction({ commit }, componentUniqueId) {
			commit(REMOVE_VALIDATION_FAILURE, componentUniqueId);
		},
		triggerValidationAction({ commit }) {
			commit(SET_VALIDATION_TRIGGER);
		},
		triggerValidationActionSuppressMessages({ commit }) {
			commit(SET_VALIDATION_TRIGGER_SUPPRESS_MESSAGES);
		}
	},
	getters: {
		validationState: state => state.validationState,
		validationTrigger: state => state.validationTrigger,
		validationTriggerSuppressMessages: state =>
			state.validationTriggerSuppressMessages
	}
};
